import { ref, computed, getCurrentInstance, onMounted } from 'vue';
import { useStore } from '@/utils/vue-api';
import { useCoreData } from '@rebuild/hooks/data/useCoreData';
import { useBusEvent } from '@rebuild/hooks/useBusEvent';

export function useHomeTabbar() {
	const vm = getCurrentInstance();
	const store = useStore();

	const menusData = ref([]);
	const displayMenus = computed(() => {
		const menuRenderLimit = 5;
		const menus = menusData.value.slice(0, menuRenderLimit);
		return menus;
	});

	const activeTab = ref(0);
	const changeTabbar = idx => {
		activeTab.value = idx;
	};

	const activeModuleId = ref(null);

	const updatePageMenus = data => {
		const { pageMenuVOS = [] } = data;
		const filterNormalMenus = pageMenuVOS.filter(v => !v.isDefault);
		menusData.value = filterNormalMenus;
	};
	const getActiveTabIndex = () => {
		const fromMuidIdx = activeByQueryMuid();
		if (fromMuidIdx !== null) return overrideActiveTab(fromMuidIdx);

		const fromActiveIdx = activeByQueryActive();
		if (fromActiveIdx !== null) return overrideActiveTab(fromActiveIdx);

		const defaultActive = 0;
		return defaultActive;
	};
	const getMenuIdWithQuery = () => {
		const { muid } = vm.proxy.$route.query;
		if (muid) {
			return muid;
		}
		return null;
	};
	const activeByQueryMuid = () => {
		const muid = getMenuIdWithQuery();
		if (muid) {
			const findMenuIndex = menusData.value.findIndex(v => v.uuid === muid);
			if (findMenuIndex !== -1) {
				return findMenuIndex;
			}
		}
		return null;
	};
	const activeByQueryActive = () => {
		const { active } = vm.proxy.$route.query;
		if (active) {
			return Number(active);
		}
		return null;
	};

	// 避免激活下标溢出
	const overrideActiveTab = idx => {
		return idx >= menusData.value.length ? 0 : idx;
	};

	// 初始化
	onMounted(() => {
		const tmplData = store.getters.getIrTemplateData;
		updatePageMenus(tmplData);
		changeTabbar(getActiveTabIndex());
	});

	// 监听模板数据变化 更新视图
	const { setIRStoreData } = useCoreData();
	useBusEvent('iframe-message', msgData => {
		const { iframePreviewData, menuId } = msgData;

		if (iframePreviewData) {
			setIRStoreData(iframePreviewData);
			updatePageMenus(iframePreviewData);
			changeTabbar(overrideActiveTab(activeTab.value));
			return;
		}

		// 菜单项选中同步
		if (menuId) {
			const menus = displayMenus.value || [];
			// 这里用的不是菜单uuid
			const targetIndex = menus.findIndex(menu => menu.id === menuId);
			if (targetIndex !== -1) {
				changeTabbar(overrideActiveTab(targetIndex));
			}
		}
	});

	return {
		menusData,
		displayMenus,
		activeTab,
		changeTabbar,
		getMenuIdWithQuery,
		activeModuleId
	};
}
